import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { DataServiceService } from '../service/data-service.service';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../service/auth.service';

export const userHasAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean> | boolean => {
  const auth = inject(AuthService);
  const dataService = inject(DataServiceService);
  const toastrService = inject(ToastrService);

  const user = auth.getUser();
  if (!user) return false;
  if (auth.isAdmin()) return true;

  const idTransaction = Number(route.params['idTransaction']);
  if (!idTransaction) return false;

  return dataService.getUserTransactions(user.idUser).pipe(
    map(result => {
      const transaction = result.find((t: any) => t.idTransaction == idTransaction);
      if (transaction) return true;
      toastrService.error('You do not have access to the information of this transaction', 'Access Error');
      return false;
    }),
    catchError(() => {
      toastrService.error('An error occurred while checking access to the transaction', 'Access Error');
      return of(false);
    })
  );
};
